import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Este sistema funciona si tengo muy poco tiempo?',
    a: 'Sí. El método está diseñado para aplicarse en solo 10 minutos al día, incluso si tienes una agenda muy ocupada.'
  }, {
    q: '¿En qué formato recibiré el producto?',
    a: 'Recibirás el ebook principal y todos los bonos en formato digital PDF con acceso inmediato después de la compra.'
  }, {
    q: '¿Necesito experiencia en organización o productividad?',
    a: 'No. El sistema fue creado para mamás ocupadas que sienten que están empezando desde cero.'
  }, {
    q: '¿Cuánto tiempo tengo acceso al material?',
    a: 'Tendrás acceso de por vida para descargar y revisar el material cuando quieras.'
  }, {
    q: '¿Hay garantía?',
    a: 'Sí. Si dentro de los primeros 7 días sientes que el producto no es para ti, puedes solicitar un reembolso.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-white md:py-32" data-id="element-1">
      <div className="px-4 mx-auto max-w-3xl sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-3">
          <motion.h2 variants={itemVariants} className="mb-12 text-3xl font-bold text-center md:text-4xl text-charcoal font-playfair" data-id="element-4">
            Preguntas Frecuentes
          </motion.h2>

          <div className="space-y-4" data-id="element-5">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <motion.div key={index} variants={itemVariants} className="bg-white border border-sage-light/40 rounded-2xl shadow-sm overflow-hidden" data-id="element-6">
                  <button onClick={() => toggleFAQ(index)} className="flex items-center justify-between w-full p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-opacity-50" aria-expanded={isOpen} data-id="element-7">
                    <span className="font-semibold text-charcoal pr-4" data-id="element-8">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-sage-dark flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-9" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-10">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-11">
                        <div className="p-6 pt-0 text-charcoal/80 leading-relaxed" data-id="element-12">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}